var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgContainer2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#aecbfa;}.cls-1,.cls-2,.cls-3{fill-rule:evenodd;}.cls-2{fill:#669df6;}.cls-3{fill:#4285f4;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon_24px_ContainerRegistry_Color") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Product Icons"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-1",
    className: "cls-1",
    points: "6.67 3 2 5.76 2 18.24 6.67 21 6.67 18.6 4 17.02 4 6.98 6.67 5.4 6.67 3"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-2",
    className: "cls-1",
    points: "9.33 9.14 12 10.71 14.67 9.14 14.67 5.98 12 4.41 9.33 5.98 9.33 9.14"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-3",
    className: "cls-2",
    points: "9.33 5.98 9.33 9.14 12 10.71 14.67 9.14 14.67 5.98 12 7.56 9.33 5.98"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-4",
    className: "cls-3",
    points: "12 10.71 14.67 9.14 14.67 5.98 12 7.56 12 10.71"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-5",
    className: "cls-1",
    points: "12.67 15.63 15.33 17.2 18 15.63 18 12.47 15.33 10.89 12.67 12.47 12.67 15.63"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-6",
    className: "cls-2",
    points: "12.67 12.47 12.67 15.63 15.33 17.2 18 15.63 18 12.47 15.33 14.05 12.67 12.47"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-7",
    className: "cls-3",
    points: "15.33 17.2 18 15.63 18 12.47 15.33 14.05 15.33 17.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-8",
    className: "cls-1",
    points: "6 15.63 8.67 17.2 11.33 15.63 11.33 12.47 8.67 10.89 6 12.47 6 15.63"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-9",
    className: "cls-2",
    points: "6 12.47 6 15.63 8.67 17.2 11.33 15.63 11.33 12.47 8.67 14.05 6 12.47"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-10",
    className: "cls-3",
    points: "8.67 17.2 11.33 15.63 11.33 12.47 8.67 14.05 8.67 17.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-11",
    className: "cls-2",
    points: "2 8.17 2 15.84 4 17.02 4 6.98 2 8.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-12",
    className: "cls-3",
    points: "2 8.17 4 7.71 4 6.98 2 8.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-13",
    className: "cls-3",
    points: "4 17.02 4 16.44 2 15.84 4 17.02"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-14",
    className: "cls-1",
    points: "17.33 3 17.33 5.4 20 6.98 20 17.02 17.33 18.6 17.33 21 22 18.24 22 5.76 17.33 3"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-15",
    className: "cls-2",
    points: "20 17.02 22 15.84 22 8.17 20 6.98 20 17.02"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-16",
    className: "cls-3",
    points: "20 7.71 22 8.17 20 6.98 20 7.71"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-17",
    className: "cls-3",
    points: "20 16.44 20 17.02 22 15.84 20 16.44"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContainer2);
export default __webpack_public_path__ + "static/media/container2.5770ad8912201e9550b48b8bff1a985c.svg";
export { ForwardRef as ReactComponent };